import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.header.menu.configure-board.display-text',
		defaultMessage: 'Configure board',
		description: 'Dropdown menu item which open the "configure board" feature',
	},
});
